import React, { useState } from "react";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import { FaEdit } from "react-icons/fa";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import PlaylistTypeModalContent from "./ModalContent/PlaylistTypeModalContent";
import EdPlaylistModalContent from "./ModalContent/EdPlaylistModalContent";
import {
  useAddPlaylist,
  useGetOutletTagsData,
  useGetPresentationTypeData,
  usePlaylistData,
  usePlaylistTypeData,
  useUpdatePlaylist,
} from "./hooks/useEdetailing";
import { BASE_URL } from "../../Api/config";
import { API_ENDPOINTS } from "../../Api/apiEndPoints";
import { downloadExcelGet } from "../../utils/ExcelDownload";
import { showToast } from "../../utils/toastUtils";
import { COLORS } from "../../constants/colors";
import axiosInstance from "../../Api/axiosInstance";
import { useExcelPolling } from "../../hooks/useExcelPolling";

const edplaylistDataColumns = (
  handleUpdate: (row: any, Status: string) => void
) => [
  {
    name: "Organisation Unit",
    canShow: true,
    selector: (row: { orgunitName: number | string }) => row.orgunitName || "-",
    sortable: true,
    wrap: true,
    width: "200px",
  },
  {
    name: "Playlist Name",
    canShow: true,
    selector: (row: { playlistname: number | string }) =>
      row.playlistname || "-",
    sortable: true,
    wrap: true,
    width: "200px",
  },
  {
    name: "Playlist Type Name",
    canShow: false,
    selector: (row: { playlisttypeid: number | string }) =>
      row.playlisttypeid || "-",
    sortable: true,
    width: "200px",
    wrap: true,
  },

  {
    name: "Presentations",
    canShow: true,
    selector: (row: { presentation: number | string }) =>
      row.presentation || "-",
    sortable: true,
    wrap: true,
    width: "200px",
  },

  {
    name: "Playlist Version",
    canShow: true,
    selector: (row: { playlistversionid: number | string }) =>
      row.playlistversionid || "-",
    sortable: true,
    width: "200px",
  },
  // {
  //   name: "Presentation Media",
  //   maxWidth: "150px",
  //   canShow: false,
  //   selector: (row: { PlaylistMedia: any }) => row.PlaylistMedia ||'-',
  //   sortable: true,
  // },
  {
    name: "Outlet Tags",
    maxWidth: "500px",
    canShow: true,
    selector: (row: { OutletTags: any }) => row.OutletTags || "-",
    sortable: true,
    wrap: true,
  },
  {
    name: "Action",
    canShow: true,
    width: "150px",
    cell: (row: any) => (
      <button
        onClick={() => handleUpdate(row, "Update")}
        className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
        style={{ borderRadius: "20px", padding: "3px", width: "70px" }}
      >
        <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
      </button>
    ),
  },
];

const EdPlaylist = () => {
  const { startPolling, stopPolling } = useExcelPolling();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [chechStatusSubmitAndUpdate, setchechStatusSubmitAndUpdate] =
    useState<string>("");
  const [selectedRow, setSelectedRow] = useState<null>(null);
  const [excelLoaing, setExcelLoading] = useState<boolean>(false);
  const [excelStatus, setExcelStatus] = useState<string>("Loading...");
  const [loadingExcel, setLoadingExcel] = useState<boolean>(false);

  const [filtersState, setFiltersState] = useState<any>({
    limit: 10,
    page: 1,
    search: null,
  });

  const { data: playlistTypeData } = usePlaylistTypeData({ enable: true });
  const {
    data: PlaylistData,
    isLoading: isLoading_PlaylistData,
    isSuccess: PlaylistData_isSuccess,
  } = usePlaylistData({
    enable: true,
    params: {
      limit: filtersState.limit,
      page: filtersState.page,
      search: filtersState.search,
    },
  });

  const { data: outletData } = useGetOutletTagsData({ enable: true });
  const { data: presentationTypeData } = useGetPresentationTypeData({
    enable: true,
  });

  // Format API data to PlaylistItem[]
  const edplaylistData = Array.isArray(PlaylistData?.rowData?.data)
    ? PlaylistData.rowData.data.map((item: any) => ({
        id: item?.PlaylistId,
        orgunit: item?.OrgunitId,
        orgunitName: item?.OrgUnit.OrgUnitName,
        playlistname: item?.PlaylistName,
        playlisttypeid: item?.PlaylistTypeId?.PlaylistTypeName,

        presentation: Array.isArray(item?.Presentations)
          ? item?.Presentations.map((p: any) => p?.PresentationName)
          : [],

        PresentationId: Array.isArray(item?.Presentations)
          ? item?.Presentations.map((p: any) => p?.PresentationId)
          : [],

        playlistversionid: item?.PlaylistVersionId,
        PlaylistMedia: item?.PlaylistMedia,
        OutletTags: item?.OutletTags,
        // PresentationId: item.PresentationId,
        // PresentationName: item.PresentationName,
      }))
    : [];
  const toggleModal = (status: string) => {
    setchechStatusSubmitAndUpdate(status);
    setIsModalOpen(!isModalOpen);
    setSelectedRow(null);
  };
  const handleClose = () => {
    setIsModalOpen(false);
    setchechStatusSubmitAndUpdate("");
  };

  const handleUpdate = (row: any, status: string) => {
    setchechStatusSubmitAndUpdate(status);

    setSelectedRow(row);
    setIsModalOpen(true);
  };

  const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };
  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  const downloadExcelGet = async () => {
    const param: Record<string, any> = {};

    const queryString = new URLSearchParams(param).toString();
    try {
      setLoadingExcel(true);
      const response = await axiosInstance.get(
        `${API_ENDPOINTS.EDETAILING.GET_EXCEL_ED_PLAYLIST}?${queryString}`
      );
      const { success, fileDownloadId, intervalTime } =
        response?.data?.data || null;
      if (success && fileDownloadId) {
        startPolling(fileDownloadId, intervalTime, {
          onStatusUpdate: (currentStatus: string) => {
            setExcelStatus(currentStatus);
          },
          onSuccess: (url: any) => {
            setLoadingExcel(false);
            setExcelStatus("Loading..");
            const a = document.createElement("a");
            a.href = url;
            a.download = "report.xlsx";
            a.click();
            showToast.success("The file is ready!");
          },
          onFailed: (msg: any) => {
            showToast.error(msg || "");
            stopPolling();
            setLoadingExcel(false);
          },
          onExpired: (msg: any) => {
            showToast.error(msg || "");
            stopPolling();
            setLoadingExcel(false);
          },
          onDeleted: (msg: any) => {
            showToast.error(msg || "");
            stopPolling();
            setLoadingExcel(false);
          },
        });
      }
    } catch (err: any) {
      showToast.error(err);
    }
  };

  return (
    <div className="p-2">
      <PageHeader
        title="Ed Playlist"
        buttons={[
          {
            label: "+ Add Ed Playlist",
            onClick: () => toggleModal("Submit"),
            color: "#2e8dd3",
          },

          {
            label: loadingExcel
              ? excelStatus
                ? excelStatus.charAt(0).toUpperCase() +
                  excelStatus.slice(1) +
                  ".."
                : ""
              : "Excel",
            onClick: () => downloadExcelGet(),
            color: loadingExcel ? COLORS.disable : COLORS.primary,
            disable: loadingExcel ? true : false,
          },
        ]}
      />
      <BasicDataTable
        paginationTotalRows={PlaylistData?.rowData?.recordsTotal || 0}
        dynamicHeightOnRowsPerPage={true}
        showSpinner={isLoading_PlaylistData}
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        Title="Playlist"
        data={
          (!isLoading_PlaylistData &&
            PlaylistData_isSuccess &&
            edplaylistData) ||
          []
        }
        columns={edplaylistDataColumns(handleUpdate)}
      />
      <RouteModal
        isOpen={isModalOpen}
        toggle={handleClose}
        title={
          chechStatusSubmitAndUpdate === "Submit"
            ? "Add EdPlaylist "
            : "Edit EdPlaylist "
        }
        size="xl"
        content={
          <EdPlaylistModalContent
            handleClose={handleClose}
            chechStatusSubmitAndUpdate={chechStatusSubmitAndUpdate}
            outletData={outletData?.data}
            playlistTypeData={playlistTypeData}
            presentationTypeData={presentationTypeData}
            selectedRow={selectedRow || {}}
          />
        }
      />
    </div>
  );
};

export default EdPlaylist;
